import {PHOTO_JPEG_QUALITY} from '../constants';
import type {ImageContentKind, OutputLadderStep} from '../types';

const JPEG_STEP: OutputLadderStep = {
  format: 'image/jpeg',
  quality: PHOTO_JPEG_QUALITY,
  flattenOnWhite: true,
};

const PNG_STEP: OutputLadderStep = {format: 'image/png', flattenOnWhite: false};

/**
 * Encoders tried in order from the same decoded bitmap until one fits the
 * destination byte cap. Graphics prefer lossless PNG (canvas WebP is not
 * portable); JPEG is the last resort so an oversize PNG still uploads.
 */
const LADDER_BY_KIND: Readonly<Record<ImageContentKind, readonly OutputLadderStep[]>> = {
  photo: [JPEG_STEP],
  graphic: [PNG_STEP, JPEG_STEP],
};

export const chooseOutputLadder = (kind: ImageContentKind): readonly OutputLadderStep[] =>
  LADDER_BY_KIND[kind];
